module.exports = __webpack_public_path__ + "img/purchase-failure.26d1c206.svg";